var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2649 2.91771C13.3746 -0.972569 6.9906 -0.972569 3.10032 2.91771C-0.789952 6.80799 -0.789952 13.192 3.10032 17.0823C6.9906 20.9726 13.2749 20.9726 17.1652 17.0823C21.1552 13.192 21.1552 6.80799 17.2649 2.91771ZM8.18761 14.9875L4.1976 10.9975L5.59412 9.60099L8.18766 12.1945L14.7712 5.61098L16.1677 7.0075L8.18761 14.9875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIconBlack);
export default __webpack_public_path__ + "static/media/done_icon_black.2540d0d92474b1aae028950fe87a04f3.svg";
export { ForwardRef as ReactComponent };